import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { sections } from '../data/sections';
interface SectionPagerProps {
  currentPath: string;
}
export function SectionPager({
  currentPath
}: SectionPagerProps) {
  const i = sections.findIndex(s => s.path === currentPath);
  const previous = i > 0 ? sections[i - 1] : null;
  const next = i >= 0 && i < sections.length - 1 ? sections[i + 1] : null;
  return <nav aria-label="Section pagination" className="mt-20 grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2" data-id="element-52" data-mp="1z62zxobe5bc">
      {previous ? <Link to={previous.path} className="group flex items-center gap-4 bg-white px-7 py-6 transition-colors duration-150 ease-out hover:bg-bone-dim" data-id="element-53" data-mp="azks784eg4k4">
          <ArrowLeftIcon className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-54" data-mp="1mc554lhibdmc" />
          <span className="min-w-0" data-id="element-55" data-mp="1hdtu47fh6x2j">
            <span className="block text-[10px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-56" data-mp="ipux2bnbo1b3">
              Previous — Section {previous.index}
            </span>
            <span className="mt-1 block font-serif text-base leading-snug text-navy" data-id="element-57" data-mp="mtauha77u5ou">
              {previous.navLabel}
            </span>
          </span>
        </Link> : <span className="hidden bg-white sm:block" data-id="element-58" data-mp="wounnoueaq9w" />}

      {next ? <Link to={next.path} className="group flex items-center justify-end gap-4 bg-white px-7 py-6 text-right transition-colors duration-150 ease-out hover:bg-bone-dim" data-id="element-59" data-mp="3v8kri3w90kpr">
          <span className="min-w-0" data-id="element-60" data-mp="8z9t08ovq4ks">
            <span className="block text-[10px] font-semibold uppercase tracking-overline text-slateink-light" data-id="element-61" data-mp="8y8efu8nmzyb">
              Next — Section {next.index}
            </span>
            <span className="mt-1 block font-serif text-base leading-snug text-navy" data-id="element-62" data-mp="3cg8qbkhbzph7">
              {next.navLabel}
            </span>
          </span>
          <ArrowRightIcon className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-63" data-mp="39ex6hsgpx8ix" />
        </Link> : <span className="hidden bg-white sm:block" data-id="element-64" data-mp="35dbo5rlf021c" />}
    </nav>;
}